var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "distribution-card row bg-light mx-auto p-3 rounded my-3" },
    [
      _c(
        "action-button",
        {
          staticClass: "close-icon",
          attrs: { i: "fa fa-times color-gray-15" },
          on: { click: _vm.onCloseDistributionDetailsButton }
        },
        [_vm._v("   ")]
      ),
      _c(
        "div",
        { staticClass: "col-md-12 p-0" },
        [
          _c("icon-view", {
            attrs: {
              icon: "fa fa-usd-circle mt-0",
              "icon-background": "#FF7058",
              "icon-color": "#fff",
              "icon-size": "18px",
              title: "Detalle de la Distribución de Pago",
              variant: "distribution-detail"
            }
          })
        ],
        1
      ),
      _c("div", { staticClass: "col-md-12 mt-3 bg-white p-3 rounded" }, [
        _vm._m(0),
        _c("hr", { staticClass: "my-3 p-0" }),
        _c(
          "div",
          { staticClass: "appointment-distribution mb-2" },
          _vm._l(_vm.data.appointmentDistribution, function(item, index) {
            return _c(
              "div",
              {
                key: `appointment-distribution-detail-${index}`,
                staticClass:
                  "appointment-distribution-content row mx-auto col-12 bg-light py-3 px-4 rounded"
              },
              [
                _c(
                  "div",
                  { staticClass: "col color-gray-6 font-weight-bold font-14" },
                  [_vm._v(" " + _vm._s(_vm.ageGroup(item)) + " ")]
                ),
                _c("div", { staticClass: "col text-black font-14" }, [
                  _vm._v(_vm._s(_vm.grantNumber(item)))
                ]),
                _c("div", { staticClass: "col text-black font-14" }, [
                  _vm._v("Cita")
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "col color-green-money font-weight-bold font-14"
                  },
                  [_vm._v(" " + _vm._s(item.amount) + " ")]
                ),
                _c("div", { staticClass: "col text-black font-14" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.amountPerAgeGroup(_vm.data.appointmentDistribution)
                      ) +
                      " "
                  )
                ])
              ]
            )
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "intervention-plan mb-2" },
          _vm._l(_vm.data.planDistribution, function(item, index) {
            return _c(
              "div",
              {
                key: `intevention-plan-distribution-detail-${index}`,
                staticClass:
                  "intevention-plan-distribution-content row mx-auto col-12 bg-light py-3 px-4 rounded"
              },
              [
                _c(
                  "div",
                  { staticClass: "col color-gray-6 font-weight-bold font-14" },
                  [_vm._v(" " + _vm._s(_vm.ageGroup(item)) + " ")]
                ),
                _c("div", { staticClass: "col text-black font-14" }, [
                  _vm._v(_vm._s(_vm.grantNumber(item)))
                ]),
                _c("div", { staticClass: "col text-black font-14" }, [
                  _vm._v("Plan Intervención")
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "col color-green-money font-weight-bold font-14"
                  },
                  [_vm._v(" " + _vm._s(item.amount) + " ")]
                ),
                _c("div", { staticClass: "col text-black font-14" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.amountPerAgeGroup(_vm.data.planDistribution)) +
                      " "
                  )
                ])
              ]
            )
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "tap-request mb-2" },
          _vm._l(_vm.data.tapRequestDistribution, function(item, index) {
            return _c(
              "div",
              {
                key: `tap-request-distribution-detail-${index}`,
                staticClass:
                  "tap-request-distribution-content row mx-auto col-12 bg-light py-3 px-4 rounded"
              },
              [
                _c(
                  "div",
                  { staticClass: "col color-gray-6 font-weight-bold font-14" },
                  [_vm._v(" " + _vm._s(_vm.ageGroup(item)) + " ")]
                ),
                _c("div", { staticClass: "col text-black font-14" }, [
                  _vm._v(_vm._s(_vm.grantNumber(item)))
                ]),
                _c("div", { staticClass: "col text-black font-14" }, [
                  _vm._v("Evaluación")
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "col color-green-money font-weight-bold font-14"
                  },
                  [_vm._v(" " + _vm._s(item.amount) + " ")]
                ),
                _c("div", { staticClass: "col text-black font-14" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.amountPerAgeGroup(_vm.data.tapRequestDistribution)
                      ) +
                      " "
                  )
                ])
              ]
            )
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "visit mb-2" },
          _vm._l(_vm.data.visitDistribution, function(item, index) {
            return _c(
              "div",
              {
                key: `visit-distribution-detail-${index}`,
                staticClass:
                  "visit-distribution-content row mx-auto col-12 bg-light py-3 px-4 rounded"
              },
              [
                _c(
                  "div",
                  { staticClass: "col color-gray-6 font-weight-bold font-14" },
                  [_vm._v(" " + _vm._s(_vm.ageGroup(item)) + " ")]
                ),
                _c("div", { staticClass: "col text-black font-14" }, [
                  _vm._v(_vm._s(_vm.grantNumber(item)))
                ]),
                _c("div", { staticClass: "col text-black font-14" }, [
                  _vm._v("Terapia")
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "col color-green-money font-weight-bold font-14"
                  },
                  [_vm._v(" " + _vm._s(item.amount) + " ")]
                ),
                _c("div", { staticClass: "col text-black font-14" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.amountPerAgeGroup(_vm.data.visitDistribution)
                      ) +
                      " "
                  )
                ])
              ]
            )
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "consulting" },
          _vm._l(_vm.data.consultingDistribution, function(item, index) {
            return _c(
              "div",
              {
                key: `consulting-distribution-detail-${index}`,
                staticClass:
                  "consulting-distribution-content row mx-auto col-12 bg-light py-3 px-4 rounded"
              },
              [
                _c(
                  "div",
                  { staticClass: "col color-gray-6 font-weight-bold font-14" },
                  [_vm._v(" " + _vm._s(_vm.ageGroup(item)) + " ")]
                ),
                _c("div", { staticClass: "col text-black font-14" }, [
                  _vm._v(_vm._s(_vm.grantNumber(item)))
                ]),
                _c("div", { staticClass: "col text-black font-14" }, [
                  _vm._v("Consultoría")
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "col color-green-money font-weight-bold font-14"
                  },
                  [_vm._v(" " + _vm._s(item.amount) + " ")]
                ),
                _c("div", { staticClass: "col text-black font-14" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.amountPerAgeGroup(_vm.data.consultingDistribution)
                      ) +
                      " "
                  )
                ])
              ]
            )
          }),
          0
        ),
        _c(
          "div",
          {
            staticClass:
              "distribution-total row mx-auto col-12 bg-green mt-2 py-3 px-4 rounded"
          },
          [
            _c(
              "div",
              { staticClass: "col text-white font-weight-bold font-14" },
              [_vm._v("Total")]
            ),
            _c("div", { staticClass: "col" }, [_vm._v(" ")]),
            _c("div", { staticClass: "col" }, [_vm._v(" ")]),
            _c(
              "div",
              { staticClass: "col text-white font-weight-bold font-14" },
              [_vm._v(" " + _vm._s(_vm.totalDistributionAmount) + " ")]
            ),
            _c(
              "div",
              { staticClass: "col text-white font-weight-bold font-14" },
              [_vm._v(" " + _vm._s(_vm.totalDistributionAmount) + " ")]
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "distribution-headers row mx-auto px-4" }, [
      _c("div", { staticClass: "col font-weight-bold text-black font-12" }, [
        _vm._v(" Grupo de Edad ")
      ]),
      _c("div", { staticClass: "col font-weight-bold text-black font-12" }, [
        _vm._v(" Número de Grant ")
      ]),
      _c("div", { staticClass: "col font-weight-bold text-black font-12" }, [
        _vm._v(" Tipo de Servicio ")
      ]),
      _c("div", { staticClass: "col font-weight-bold text-black font-12" }, [
        _vm._v("Monto")
      ]),
      _c("div", { staticClass: "col font-weight-bold text-black font-12" }, [
        _vm._v(" Total de la Distribución por Edad ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }